namespace $.$$ {

	type Form2_relation_page = {
		dataset: string
		record: string
		parent_label: string
		parent?: { dataset: string, record: string }
		source?: { dataset: string, field: string, record: string }
	}

	export class $shm_hitalama_map_widget_float_form2_relation_form extends $shm_hitalama_map_widget_float_table_form {
		@ $mol_mem
		host( next?: $shm_hitalama_map_widget_float_form2 ) { return next ?? null! }
		@ $mol_mem
		page_index( next?: number ) { return next ?? 0 }
		table() { return this.host() as unknown as $shm_hitalama_map_widget_float_table }
		custom() { return this.host().relation_dataset( this.page_index() )! }
		row_index() { return this.host().relation_row_index( this.page_index() ) }
		title() { return this.host().relation_title( this.page_index() ) }
		data_value( name: string, next?: any ) { return this.host().relation_value( this.page_index(), name, next ) }
		field_link_options( name: string ) { return this.custom().field_link_options( name ) }
		field_select_dictionary( name: string ) {
			return Object.fromEntries( this.custom().field_select_options( name ).map( ( value: string )=> [ value, value ] ) )
		}
		field_relation_active( name: string ) { return this.host().relation_active( this.page_index(), name ) }
		@ $mol_action
		field_relation_open( name: string, link?: string ) {
			if( link !== undefined ) this.host().relation_open( this.page_index(), name, link )
			return link ?? ''
		}
		@ $mol_action
		field_relation_create( name: string, event?: Event ) {
			if( event ) this.host().relation_create( this.page_index(), name )
			return event ?? null
		}
		field_relation_create_current( name: string ) {
			const next = this.host().relation_page( this.page_index() + 1 )
			return !!next && !next.record && next.source?.field === this.custom().field( name )?.link().str
		}
		@ $mol_action
		submit() {
			if( !this.submit_allowed() ) return
			for( const name of this.custom().input_field_names() ) {
				if( this.custom().field_type( name ) === 'file' ) this.field_value( name )
			}
			this.host().relation_submit( this.page_index(), this.custom().object_current() )
		}
		@ $mol_action
		close( event?: Event ) {
			if( event ) this.host().relation_close( this.page_index() )
			return event ?? null
		}
	}

	export class $shm_hitalama_map_widget_float_form2 extends $.$shm_hitalama_map_widget_float_form2 {
		form_self() { return this }
		fullscreen() { return this.$.$mol_state_arg.value( 'fullscreen_widget' ) === this.widget().link_str() }
		dataset_by_link( link: string | undefined ) {
			return link ? this.$.$giper_baza_glob.Pawn(
				new this.$.$giper_baza_link( link ),
				this.$.$shm_hitalama_map_widget_entity_table2_dataset,
			) : null
		}
		form_workspace_content() {
			const pages = this.relation_pages()
			return this.fullscreen() && pages.length ? [ this.Relation_panel( pages.length - 1 ) ] : [ this.Form() ]
		}
		@ $mol_mem
		relation_pages( next?: readonly Form2_relation_page[] ) { return next ?? [] }
		relation_page( index: number ) { return this.relation_pages()[ index ] ?? null }
		relation_dataset( index: number ) {
			const link = this.relation_page( index )?.dataset
			return this.dataset_by_link( link )
		}
		relation_record( index: number ) {
			const link = this.relation_page( index )?.record
			return this.relation_dataset( index )?.record_by_link( link ) ?? null
		}
		relation_row_index( index: number ) {
			const record = this.relation_record( index )
			return record ? this.relation_dataset( index )!.records().indexOf( record ) : -1
		}
		relation_title( index: number ) {
			const page = this.relation_page( index )
			const dataset = this.relation_dataset( index )
			const title = this.map().Widgets_list()?.remote_list().find( widget =>
				widget.type() === 'table2' && widget.Dataset()?.remote()?.link().str === dataset?.link().str )?.title() ?? 'Таблица'
			const parent = page?.parent
			const parent_dataset = this.dataset_by_link( parent?.dataset )
			const parent_record = parent_dataset?.record_by_link( parent?.record ?? '' )
			const label = parent_dataset && parent_record ? this.first_label( parent_dataset, parent_record ) : page?.parent_label
			return label ? `${ title } - ${ label }` : title
		}
		first_label( dataset: $shm_hitalama_map_widget_entity_table2_dataset,
			record: $shm_hitalama_map_widget_entity_table2_record ) {
			const field = dataset.fields()[0]
			return String( field ? record.value( field ) ?? '' : '' )
		}
		relation_value( index: number, name: string, next?: any ) {
			const dataset = this.relation_dataset( index )
			const field = dataset?.field( name )
			const record = this.relation_record( index )
			if( !dataset || !field ) return ''
			if( !record ) return dataset.object_current_value( name, next )
			return record.value( field, next )
		}
		relation_active( index: number, name: string ) {
			const next = this.relation_page( index + 1 )
			const source = index < 0 ? this.custom() : this.relation_dataset( index )
			return next?.dataset === source?.field_target_dataset( name )?.link().str ? next.record : ''
		}
		@ $mol_action
		relation_close( index: number ) { this.relation_pages( this.relation_pages().slice( 0, index ) ) }
		@ $mol_action
		relation_open( from: number, name: string, link: string ) {
			const source_dataset = from < 0 ? this.custom() : this.relation_dataset( from )
			const source_record = from < 0 ? this.record() : this.relation_record( from )
			const target = source_dataset?.field_target_dataset( name )
			const record = target?.record_by_link( new $giper_baza_link( link ).str )
			if( !target || !record ) {
				$shm_hitalama_notifications.warning( 'Связанная запись не найдена' )
				return
			}
			const current = this.relation_page( from + 1 )
			if( current?.record === record.link().str && current.dataset === target.link().str ) {
				this.relation_close( from + 1 )
				return
			}
			this.relation_pages([ ...this.relation_pages().slice( 0, from + 1 ), {
				dataset: target.link().str, record: record.link().str,
				parent_label: source_dataset && source_record ? this.first_label( source_dataset, source_record ) : '',
				parent: source_dataset && source_record ? { dataset: source_dataset.link().str, record: source_record.link().str } : undefined,
			} ])
		}
		@ $mol_action
		relation_create( from: number, name: string ) {
			const source_dataset = from < 0 ? this.custom() : this.relation_dataset( from )
			const source_record = from < 0 ? this.record() : this.relation_record( from )
			const field = source_dataset?.field( name )
			const target = field?.target_dataset()
			if( !source_dataset || !source_record || !field || !target ) {
				$shm_hitalama_notifications.warning( 'Сначала сохраните запись и выберите связанную таблицу' )
				return
			}
			target.draft_relation_prepare( field, source_record )
			this.relation_pages([ ...this.relation_pages().slice( 0, from + 1 ), {
				dataset: target.link().str, record: '',
				parent_label: this.first_label( source_dataset, source_record ),
				parent: { dataset: source_dataset.link().str, record: source_record.link().str },
				source: { dataset: source_dataset.link().str, field: field.link().str, record: source_record.link().str },
			} ])
		}
		@ $mol_action
		relation_submit( index: number, object: Record< string, any > ) {
			const page = this.relation_page( index )
			if( !page ) return
			if( page.source ) {
				const dataset = this.relation_dataset( index )
				const source_dataset = this.dataset_by_link( page.source.dataset )
				const field = source_dataset?.fields().find( item => item.link().str === page.source?.field )
				const source_record = source_dataset?.record_by_link( page.source?.record ?? '' )
				if( !dataset || !field || !source_record ) return
				const created = dataset.record_add( object )
				const current = source_record.value( field )
					source_record.value( field, field.type() === 'list_link'
						? [ ...new Set([ ...( Array.isArray( current ) ? current : [] ), created.link().str ]) ] : created.link().str )
				dataset.draft_reset()
				this.relation_close( index )
				$shm_hitalama_notifications.success( 'Запись создана' )
			} else {
				this.relation_close( index )
				$shm_hitalama_notifications.success( 'Запись обновлена' )
			}
		}
		override field_relation_active( name: string ) {
			if( this.fullscreen() ) return this.relation_active( -1, name )
			return super.field_relation_active( name )
		}
		@ $mol_action
		override field_relation_open( name: string, link?: string ) {
			if( this.fullscreen() ) {
				if( link !== undefined ) this.relation_open( -1, name, link )
				return link ?? ''
			}
			return super.field_relation_open( name, link )
		}
		@ $mol_action
		override field_relation_create( name: string, event?: Event ) {
			if( this.fullscreen() ) {
				if( event ) this.relation_create( -1, name )
				return event ?? null
			}
			return super.field_relation_create( name, event )
		}

		override custom() {
			return this.widget().dataset()
		}

		record() {
			return this.widget().Record2()?.remote()
		}

		@ $mol_mem_key
		data_value( name: string, next?: any ) {
			const record = this.record()
			if( !record ) return this.custom().object_current_value( name, next )
			const field = this.custom().fields().find( field => field.title() === name )
			if( !field ) return ''
			return record.value( field, next )
		}

		@ $mol_action
		override submit() {
			if( !this.submit_allowed() ) return

			if( this.record() ) {
				// File fields keep the selected native File separately until their value
				// is read. Materialize them before reporting that the record was saved.
				for( const name of this.custom().input_field_names() ) {
					if( this.custom().field_type( name ) === 'file' ) this.field_value( name )
				}
				this.submit_result( 'Запись обновлена' )
				$shm_hitalama_notifications.success( 'Запись обновлена' )
				return
			}

			const object = this.custom().object_current()
			const record = this.custom().record_add( object )
			const source_record = this.widget().Relation_source_record()?.remote()
			const source_field = this.widget().Relation_source_field()?.remote()
			if( source_record && source_field ) {
				const current = source_record.value( source_field )
				source_record.value( source_field, source_field.type() === 'list_link'
					? [ ...new Set([ ...( Array.isArray( current ) ? current : [] ), record.link().str ]) ]
					: record.link().str )
			}
			const source_table = this.widget().Relation_source_table()?.remote()
			const source_row = this.widget().Relation_source_row()?.val()
			const source_name = this.widget().Relation_source_name()?.val()
			if( source_table && source_row != null && source_name ) {
				const custom = source_table.form_custom()
				const objects = [ ...custom?.objects() ?? [] ] as Record< string, any >[]
				const source = objects[ source_row ]
				if( source ) {
					const current = source[ source_name ]
					objects[ source_row ] = { ...source, [ source_name ]: custom?.field_type( source_name ) === 'list_link'
						? [ ...new Set([ ...( Array.isArray( current ) ? current : [] ), record.link().str ]) ] : record.link().str }
					custom?.objects( objects )
				}
			}
			;( this as unknown as $shm_hitalama_map_widget_float_form_custom ).fields_clear()
			this.custom().draft_reset()
			if( source_record && source_field || source_table && source_name ) {
				this.widget().Record2( null )?.val( new $giper_baza_link( record.link().str ) )
			}
			const message = `Создана запись №${ this.custom().records().length }`
			this.submit_result( message )
			$shm_hitalama_notifications.success( message )
			return record
		}

	}

}
